<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_slots_title')"
                        :isNewButton="false"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_slots_title')"
                              :isNewButton="false"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus=$event"
                >
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
                :export-excel="checkPermission('studentslot_allslotanalysisreport')"
                @exportExcel="downloadExcel">
                <b-row>
                    <!-- FILTER -- STUDENT NUMBERS -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('student_number_long')">
                            <multi-text v-model="datatable.queryParams.filter.student_number"
                                        :only-number-and-enter="true"
                            />
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- ACADEMIC YEARS -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="datatable.queryParams.filter.academic_year"
                                                      :multiple="true"></academic-years-selectbox>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('student_status')">
                            <parameter-selectbox code="student_statuses"
                                                 v-model="datatable.queryParams.filter.student_status">
                            </parameter-selectbox>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- SEMESTERS -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('semester')">
                            <parameter-selectbox code="semester" v-model="datatable.queryParams.filter.semester"
                                                 :multiple="true"></parameter-selectbox>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- COURSE CODES -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('course_code')">
                            <multi-text v-model="datatable.queryParams.filter.course_code"></multi-text>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- COURSE NAMES -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('course_name')">
                            <multi-text v-model="datatable.queryParams.filter.course_name"></multi-text>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- SECTIONS -->
                    <!--                    <b-col sm="12" md="6" lg="3">-->
                    <!--                        <b-form-group :label="$t('theoric_section')">-->
                    <!--                            <multi-text v-model="datatable.queryParams.filter.section"></multi-text>-->
                    <!--                        </b-form-group>-->
                    <!--                    </b-col>-->

                    <!-- FILTER -- LAB SECTIONS -->
                    <!--                    <b-col sm="12" md="6" lg="3">-->
                    <!--                        <b-form-group :label="$t('lab_section')">-->
                    <!--                            <multi-text v-model="datatable.queryParams.filter.lab_section_id"></multi-text>-->
                    <!--                        </b-form-group>-->
                    <!--                    </b-col>-->

                    <!-- FILTER -- SECTION LANGUAGES -->
                    <!--                    <b-col sm="12" md="6" lg="3">-->
                    <!--                        <b-form-group :label="$t('language')">-->
                    <!--                            <parameter-selectbox code="languages" v-model="datatable.queryParams.filter.section_language"-->
                    <!--                                                :multiple="true"></parameter-selectbox>-->
                    <!--                        </b-form-group>-->
                    <!--                    </b-col>-->

                    <!-- FILTER -- COURSE TYPES -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('course_type')">
                                                <parameter-selectbox code="course_types" size="sm"
                                                                     v-model="datatable.queryParams.filter.course_type"
                                                                     :multiple="true"></parameter-selectbox>
                                            </b-form-group>
                                        </b-col>-->

                    <!-- FILTER -- GRADE SYSTEMS / LETTER GRADE / GRADE SCALA -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('grade_scala')">
                                                <grade-system-selectbox size="sm"
                                                                        v-model="datatable.queryParams.filter.grading_system_id"
                                                />
                                            </b-form-group>
                                        </b-col>-->

                    <!-- FILTER -- SLOT TYPES -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('slot_type')">
                            <slot-type-selectbox size="sm" v-model="datatable.queryParams.filter.slot_type"
                                                 :multiple="true"></slot-type-selectbox>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- NATIONAL CREDIT BETWEEN -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('credit')">
                            <credit-between size="sm"
                                            v-model="datatable.queryParams.filter.credit_between"></credit-between>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- MODALITY -->
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('modality')">
                            <parameter-selectbox code="section_processing_types"
                                                 v-model="datatable.queryParams.filter.theoretical_model"></parameter-selectbox>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('slot_status')">
                            <status-selectbox v-model="datatable.queryParams.filter.slot_status" :setOptions="options"></status-selectbox>
                        </b-form-group>
                    </b-col>

                    <!-- FILTER -- GRADES -->
<!--                    <b-col sm="12" md="6" lg="3">-->
<!--                        <b-form-group :label="$t('letter_grade')">-->
<!--                            <grade-selectbox v-model="datatable.queryParams.filter.letter_grade"-->
<!--                                             :grading_system_id="datatable.queryParams.filter.grading_system_id"-->
<!--                                             :multiple="true"-->
<!--                                             valueType="grade"-->
<!--                            />-->
<!--                        </b-form-group>-->
<!--                    </b-col>-->


                    <!-- FILTER -- REGISTRATION TYPES / GIRIS TURU -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('registration_type')">
                                                <parameter-selectbox code="registration_types" size="sm"
                                                                     v-model="datatable.queryParams.filter.registration_type"
                                                                     :multiple="true"></parameter-selectbox>
                                            </b-form-group>
                                        </b-col>-->

                    <!-- FILTER -- STUDENT STATUSES -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('student_status')">
                                                <parameter-selectbox code="student_statuses" size="sm"
                                                                     v-model="datatable.queryParams.filter.student_status"
                                                                     :multiple="true"></parameter-selectbox>
                                            </b-form-group>
                                        </b-col>-->

                    <!-- FILTER -- SEMESTER STATUSES -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('semester_status')">
                                                <parameter-selectbox code="semester_statuses" size="sm"
                                                                     v-model="datatable.queryParams.filter.semester_status"
                                                                     :multiple="true"></parameter-selectbox>
                                            </b-form-group>
                                        </b-col>-->

                    <!-- FILTER -- FACULTIES -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('faculty')">
                                                <faculty-selectbox size="sm" v-model="datatable.queryParams.filter.faculty_code"
                                                                   :multiple="true"></faculty-selectbox>
                                            </b-form-group>
                                        </b-col>-->

                    <!-- FILTER -- PROGRAMS -->
                    <!--
                                        <b-col sm="12" md="6" lg="6">
                                            <b-form-group :label="$t('program')">
                                                <program-selectbox size="sm" v-model="datatable.queryParams.filter.student_program_id" :faculty_code="datatable.queryParams.filter.faculty_code"
                                                                   :department_code="datatable.queryParams.filter.department_code" :multiple="true"></program-selectbox>
                                            </b-form-group>
                                        </b-col>
                    -->

                    <!-- FILTER -- DEPARTMENTS -->
                    <!--
                                        <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('department')">
                                                <department-selectbox size="sm" v-model="datatable.queryParams.filter.department_code"
                                                                      :faculty_code="datatable.queryParams.filter.faculty_code"
                                                                      :multiple="true"></department-selectbox>
                                            </b-form-group>
                                        </b-col>
                    -->


                    <!-- FILTER -- CLASSES -->
                    <!--                    <b-col sm="12" md="6" lg="3">
                                            <b-form-group :label="$t('class')">
                                                <parameter-selectbox code="classes" size="sm" v-model="datatable.queryParams.filter.class"
                                                                     :multiple="true"></parameter-selectbox>
                                            </b-form-group>
                                        </b-col>-->
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import DatatableFilter from '@/components/datatable/DatatableFilter';
import Datatable from '@/components/datatable/Datatable';
import MultiText from '@/components/interactive-fields/MultiText';
import AcademicYearsSelectbox from '@/components/interactive-fields/AcademicYearsSelectbox';
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';
import GradeSystemSelectbox from '@/components/interactive-fields/GradeSystemSelectbox';
import SlotTypeSelectbox from '@/components/interactive-fields/SlotTypeSelectbox';
import CreditBetween from '@/components/interactive-fields/CreditBetween';
import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox';
import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
import ProgramSelectbox from '@/components/interactive-fields/ProgramSelectbox';
import GradeSelectbox from '@/components/interactive-fields/GradeSelectbox';
import qs from 'qs'
import StudentSlotService from "@/services/StudentSlotService";
import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox.vue";

export default {
    components: {
        StatusSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        MultiText,
        AcademicYearsSelectbox,
        ParameterSelectbox,
        GradeSystemSelectbox,
        SlotTypeSelectbox,
        CreditBetween,
        FacultySelectbox,
        DepartmentSelectbox,
        ProgramSelectbox,
        GradeSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('student_slots_title')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: this.$t('id').toUpper(),
                        field: 'id',
                        hidden: true
                    },
                    {
                        label: this.$t('student_number').toUpper(),
                        field: 'student_number',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('name').toUpper(),
                        field: 'name',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('surname').toUpper(),
                        field: 'surname',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('course_code').toUpper(),
                        field: 'course_code',
                        hidden: false,
                        sortable: false,
                        formatFn: (value, row) => {
                            return row .course?.code;
                        },
                    },
                    {
                        label: this.$t('course_name').toUpper(),
                        field: 'course_name',
                        hidden: false,
                        sortable: false,
                        formatFn: (value, row) => {
                            return row .course?.name;
                        },
                    },
                    {
                        label: this.$t('course_type').toUpper(),
                        field: 'course.type',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('semester').toUpper(),
                        field: 'semester',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('section').toUpper(),
                        field: 'section',
                        hidden: false,
                        sortable: false
                    },
                   /* {
                         label: this.$t('lab_section').toUpper(),
                         field: 'lab_section_number',
                         hidden: false,
                         sortable: false
                    },
                    {
                         label: this.$t('language').toUpper(),
                         field: 'section_language',
                         hidden: false,
                         sortable: false
                    },
                    {
                           label: this.$t('course_type').toUpper(),
                           field: ('course_type'),
                           hidden: false,
                           sortable: false
                    },
                    {
                         label: this.$t('grade_scala').toUpper(),
                         field: 'grade_system_id',
                         hidden: false,
                         sortable: false
                    },*/
                    {
                        label: this.$t('slot_type').toUpper(),
                        field: ('slot_type_name'),
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('credit').toUpper(),
                        field: 'credit',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('registration_type').toUpper(),
                        field: ('registration_type'),
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('student_status').toUpper(),
                        field: 'student_status',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('semester_status').toUpper(),
                        field: 'semester_status_name',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('department_code').toUpper(),
                        field: 'course.department_code',
                        hidden: false,
                        sortable: false
                    },
                    /*{
                            label: this.$t('grade_scala').toUpper(),
                            field: 'grading_system_name',
                            hidden: false,
                            sortable: false
                    },
                    {
                         label: this.$t('student_status').toUpper(),
                         field: 'student_status',
                         hidden: false,
                         sortable: false
                    },
                    {
                         label: this.$t('student_status').toUpper(),
                         field: 'student_status',
                         hidden: false,
                         sortable: false
                    },
                    {
                        label: this.$t('faculty').toUpper(),
                        field: 'faculty_name',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('program_code').toUpper(),
                        field: 'program_code',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.$t('class').toUpper(),
                        field: 'class',
                        hidden: false,
                        sortable: false
                    },*/
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: '-id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {},
            studentSlots: [],
            options: [
                { text: this.$t('success'), value: 1 },
                { text: this.$t('taking_during_current_semester'), value: 2 },
                { text: this.$t('unsuccessful'), value: 3 },
                { text: this.$t('not_taken'), value: 4 },
                { text: this.$t('awaiting_grading'), value: 5 }
            ]
        }
    },
    created() {
        this.filterSet();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {
                student_number: '',
                semester: '',
                course_code: '',
                course_name: '',
                // course_type: '',
                //  grading_system_id: '',
                slot_type: '',
                credit_between: '',
                // registration_type: '',
                // student_status: '',
                // semester_status: '',
                // faculty_code: '',
                // department_code: '',
                student_program_id: '',
                // class: '',
                theoretical_model: '',
                letter_grade: '',
                academic_year: '',
                slot_status: '',
            };
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                    sort: 'id'
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };

            return StudentSlotService.getSlots(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                    this.studentSlots = response.data.data;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        downloadExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            StudentSlotService.downloadAsAllSlot(config)
                .then(response => {
                    this.$toast.success(this.$t('proccess_success'))
                    this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                })
                .catch(e => {
                    this.showErrors(e, this.$refs.importForm)
                })
        }
    }
}
</script>

